import React, { useEffect, useRef } from "react";
import {
  Container,
  Navbar,
  Nav,
  NavLink,
  Offcanvas,
  NavDropdown,
  Dropdown,
} from "react-bootstrap";

import { useWeb3Modal } from "@web3modal/wagmi/react";
import { useAccount, useSwitchChain } from "wagmi";

import throttle from "lodash.throttle";

import CoinLogo from "../../assets/icons/coin-logo.svg";
import {
  MENU_DEVELOPER,
  MENU_EDU_CHAIN,
  MENU_FUNDING,
  MENU_PRODUCTS,
} from "../../constants";

import menuBar from "../../assets/icons/menu-bar.svg";
import chevronDown from "../../assets/icons/chevron-down.svg";
import publisher from "../../assets/icons/header/publisher.svg";
import publisherMobile from "../../assets/icons/header/mobile/publisher.svg";
import dropdownMobileSubLevel from "../../assets/icons/dropdown-mobile.svg";

// import './Header.scss'

function displayWallet(str, head = 6, tail = 4) {
  return str.slice(0, head) + "..." + str.slice(str.length - tail);
}

const renderDropItems = (items) => {
  return items.map((item) => (
    <NavDropdown.Item href={item.url} key={item.title}>
      <React.Fragment>
        <img className={"mx-1 d-none d-lg-inline"} src={item.icon} alt={""} />
        <img
          className={"mx-1 d-inline d-lg-none"}
          src={item.iconMobile}
          alt={""}
        />
        {item.title}
      </React.Fragment>
    </NavDropdown.Item>
  ));
};

export function Header() {
  const { address, status, chainId } = useAccount();
  const { chains, switchChain } = useSwitchChain();
  const { open } = useWeb3Modal();
  const ref = useRef();

  const handleConnect = async () => {
    try {
      open();
      // await sdk.connect()
    } catch (e) {
      console.warn(e);
    }
  };

  useEffect(() => {
    const handleChangeHeaderStyle = () => {
      if (ref && ref.current) {
        if (window.scrollY > 50) {
          ref.current.style.backgroundColor = "#FFFFFF";
          ref.current.style.boxShadow = "0px 1px 4px 0px rgba(0,0,0,0.4)";
        } else {
          ref.current.style.backgroundColor = "transparent";
          ref.current.style.boxShadow = "none";
        }
        // debug
        // console.log(new Date())
      }
    };

    const handleChangeStyleThrottle = throttle(handleChangeHeaderStyle, 200);

    window.addEventListener("scroll", handleChangeStyleThrottle);

    return () => {
      window.removeEventListener("scroll", handleChangeStyleThrottle);
    };
  }, []);

  return (
    <Navbar
      ref={ref}
      sticky="top"
      id="staking-nav"
      expand="lg"
      collapseOnSelect
    >
      <Container className="header-container">
        <Navbar.Brand
          href="https://opencampus.xyz/"
          style={{ cursor: "pointer" }}
        >
          <img className="campus-icon" alt="" src={CoinLogo} width={32} />
          <h5>
            <b>Open Campus</b>
          </h5>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="oc-staking-nav">
          <img src={menuBar} alt={""} />
        </Navbar.Toggle>
        <Navbar.Offcanvas id="oc-staking-nav" placement="end">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>MENU</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className={"w-100"}>
            <Nav>
              <div className={"navbar-root-container"}>
                <Nav.Item>
                  <NavLink href="/">Home</NavLink>
                </Nav.Item>
                <Nav.Item>
                  <NavDropdown
                    id="nav-dropdown"
                    title={
                      <React.Fragment>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={(event) => {
                            event.stopPropagation();
                            event.preventDefault();

                            window.open("https://educhain.xyz/", "_self");
                          }}
                        >
                          EDU Chain
                        </span>
                        <img
                          className={"chevron-down"}
                          src={chevronDown}
                          alt={""}
                        />
                      </React.Fragment>
                    }
                  >
                    <div className={"dropdown-level-2-container"}>
                      {renderDropItems(MENU_EDU_CHAIN)}
                    </div>
                  </NavDropdown>
                </Nav.Item>
                <Nav.Item>
                  <NavDropdown
                    id="nav-dropdown"
                    title={
                      <React.Fragment>
                        <span>Product</span>
                        <img
                          className={"chevron-down"}
                          src={chevronDown}
                          alt={""}
                        />
                      </React.Fragment>
                    }
                  >
                    <div className={"dropdown-level-2-container"}>
                      {renderDropItems(MENU_PRODUCTS)}
                    </div>
                  </NavDropdown>
                </Nav.Item>
                <Nav.Item>
                  <NavDropdown
                    id="nav-dropdown"
                    title={
                      <React.Fragment>
                        <span>Developers</span>
                        <img
                          className={"chevron-down"}
                          src={chevronDown}
                          alt={""}
                        />
                      </React.Fragment>
                    }
                  >
                    <div className={"dropdown-level-2-container"}>
                      {renderDropItems(MENU_DEVELOPER)}
                    </div>
                  </NavDropdown>
                </Nav.Item>
                <Nav.Item>
                  <NavDropdown
                    id="nav-dropdown"
                    title={
                      <React.Fragment>
                        <span>Funding</span>
                        <img
                          className={"chevron-down"}
                          src={chevronDown}
                          alt={""}
                        />
                      </React.Fragment>
                    }
                  >
                    <div className={"dropdown-level-2-container"}>
                      {renderDropItems(MENU_FUNDING)}
                    </div>
                  </NavDropdown>
                </Nav.Item>
                <Nav.Item>
                  <NavLink href="https://dao.opencampus.xyz">
                    DAO
                  </NavLink>
                </Nav.Item>
              </div>
              {status == "connected" && address ? (
                <>
                  <div
                    className="wallet-bubble mb-1 mb-md-0 mx-0 mx-md-1"
                    onClick={() => {
                      window.open("https://dashboard.educhain.xyz/", "_self");
                    }}
                  >
                    Dashboard
                  </div>
                  <Dropdown>
                    <Dropdown.Toggle id="network-select">
                      {chains.find((chain) => chain.id === chainId)?.name ||
                        "Switch Network"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {chains.map((chain) => (
                        <Dropdown.Item
                          key={chain.id}
                          onClick={() => switchChain({ chainId: chain.id })}
                        >
                          {chain.name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  <div className="wallet-bubble">{displayWallet(address)}</div>
                </>
              ) : (
                <div className="wallet-bubble" onClick={handleConnect}>
                  Connect Wallet
                </div>
              )}
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
}
